export const LOG_LEVEL_FORMATTERS = {
    bold: "\x1b[1m",
    dim: "\x1b[2m",
    underline: "\x1b[4m",
    invertBackground: "\x1b[7m",
    hidden: "\x1b[8m",
    error: "\u001b[31m\x1b[1m",
    redText: "\u001b[31m\x1b[1m", // Same ANSI style as error but in log level printing important errors
    warning: "\u001b[33m\x1b[1m",
    yellowText: "\u001b[33m\x1b[1m", // Same ANSI style as warning but in log level printing important warnings
    log: "\x1b[0m\u001b[0m",
};
//# sourceMappingURL=formatters.js.map